import { useState } from "react";
import CommunicationSideMenu, {
  CommunicationMenuItem,
} from "@/components/communication/CommunicationSideMenu";
import CustomReport from "./options/CustomReport";
import EstandardReport from "./options/EstandardReport";

export default function CommunicationHome() {
  const [selectedCategory, setSelectedCategory] = useState<
    CommunicationMenuItem | undefined
  >();

  const handleCategorySelect = (category: CommunicationMenuItem) => {
    setSelectedCategory(category);
  };

  // Render the appropriate component based on the selected category
  const renderCategoryContent = () => {
    if (!selectedCategory) return null;

    switch (selectedCategory?.name?.toLowerCase()) {
      case "estandard":
        return <EstandardReport />;
      case "custom":
        return <CustomReport />;
      default:
        return <EstandardReport />;
    }
  };

  return (
    <div className="flex h-full">
      {/* Side Menu with Company Selector */}
      <CommunicationSideMenu
        onCategorySelect={handleCategorySelect}
        selectedCategoryId={selectedCategory?.name}
      />

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        <div className="sm:flex-auto">{renderCategoryContent()}</div>
      </div>
    </div>
  );
}
